/**
 * =============================================================================
 * BjornEvers.tsx - Björn Evers Author Profile Page
 * =============================================================================
 *
 * ROUTE: /om-oss/bjorn-evers
 *
 * PURPOSE:
 *   Dedicated profile page for Björn Evers, founder and CEO of Caire
 *   E-E-A-T compliant author page for YMYL content
 *
 * CONTENT:
 *   - Full biography with MS diagnosis story
 *   - Credentials and qualifications
 *   - LinkedIn verification
 *   - List of articles authored by Björn
 *
 * TARGET AUDIENCE: Anyone wanting to learn more about Björn's expertise
 *
 * SEO FOCUS: E-E-A-T signals, author credibility for healthcare content
 * =============================================================================
 */

import React from "react";
import { AuthorPage, bjornEvers } from "@appcaire/shared/seo";

const BjornEversPage: React.FC = () => {
  // List of articles by Björn on Nacka Hemtjänst
  const articles = [
    {
      title: "Hitta hemtjänst i Nacka | Komplett Guide",
      url: "/hitta-hemtjanst",
      publishDate: "2026-01-20",
      description:
        "Din guide till att hitta och välja hemtjänst i Nacka kommun.",
    },
    {
      title: "Ansök om hemtjänst i Nacka",
      url: "/ansoka",
      publishDate: "2026-01-20",
      description:
        "Så ansöker du om hemtjänst i Nacka kommun - steg för steg guide.",
    },
    {
      title: "Dina rättigheter inom hemtjänsten i Nacka",
      url: "/rattigheter",
      publishDate: "2026-01-20",
      description:
        "Lär dig om dina rättigheter och Nacka kommuns ansvar när du tar emot hemtjänst.",
    },
    {
      title: "Hushållsnära tjänster i Nacka",
      url: "/hushallsnara-tjanster",
      publishDate: "2026-01-20",
      description:
        "Information om RUT-avdrag och hushållsnära tjänster som komplement till hemtjänst i Nacka.",
    },
    {
      title: "Vanliga frågor och svar om hemtjänst i Nacka",
      url: "/vanliga-fragor-och-svar",
      publishDate: "2026-01-25",
      description:
        "Svar på de vanligaste frågorna om hemtjänst specifikt i Nacka kommun.",
    },
  ];

  return (
    <AuthorPage
      author={bjornEvers}
      siteName="Nacka Hemtjänst"
      siteUrl="https://nackahemtjanst.se"
      articles={articles}
      backUrl="/om-nacka-hemtjanst"
    />
  );
};

export default BjornEversPage;
